export enum AbgSource {
    listResultsContainer = 'listResultsContainer',
    addLink = 'addLink',
}
